import { useEffect } from "react";
import { App } from "@capacitor/app";
import { PluginListenerHandle } from "@capacitor/core";
import { getDismissOpenSheet } from "./useDismissSheet";
import { isNativeApp } from "./platform";

export const useAndroidBackButton = (fallback: () => void) => {
  useEffect(() => {
    if (!isNativeApp()) return;

    let backButtonListener: PluginListenerHandle;

    const setupListener = async () => {
      backButtonListener = await App.addListener("backButton", () => {
        const dismiss = getDismissOpenSheet();
        if (dismiss) {
          dismiss();
          return;
        }
        fallback();
      });
    };

    setupListener();

    return () => {
      if (backButtonListener) {
        backButtonListener.remove();
      }
    };
  }, [fallback]);
};
